<template>
  <div class="mb-4">
    <p class="subheading font-weight-regular mb-0">
      Habitación
      <span class="text-uppercase">{{ data.nombre }}</span>
    </p>
    <v-data-table :headers="header" :items="rows" class="elevation-1" hide-actions :expand="expand" item-key="unique">
      <template v-slot:headers="props">
        <tr style="height: 30px;">
          <th v-for="(th, thin) in props.headers" :key="`th-${thin}`" class="grey lighten-2 black--text text-xs-center">
            {{ th.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr class="text-xs-center">
          <td style="height: 30px;">{{ props.item.hab }}</td>
          <td style="height: 30px;">{{ props.item.SGL == 0 ? "-" : props.item.SGL }}</td>
          <td style="height: 30px;">{{ props.item.DBL == 0 ? "-" : props.item.DBL }}</td>
          <td style="height: 30px;">{{ props.item.TPL == 0 ? "-" : props.item.TPL }}</td>
          <td style="height: 30px;">{{ props.item.CPL == 0 ? "-" : props.item.CPL }}</td>
          <td style="height: 30px;">{{ props.item.CHD == 0 ? "-" : props.item.CHD }}</td>
          <td style="height: 30px;">{{ props.item.JR == 0 ? "-" : props.item.JR }}</td>
          <td style="height: 30px;">
            <span v-if="Object.keys(props.item.observacion).length != 0">{{ props.item.observacion }}</span>
          </td>
          <td style="height: 30px;">
            <a @click="props.expanded = !props.expanded">
              <v-icon small>fas fa-eye</v-icon>
            </a>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat class="pa-4">
          <ul>
            <li class="green--text" v-for="(c, cind) in props.item.caracteristicas" :key="`crt-${cind}`">
              <span>{{ c }}</span>
            </li>
          </ul>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "panelTarifario",
  props: ["data"],
  components: {},
  mounted() {
    this.init()
  },
  created() {},
  methods: {
    init() {
      let _this = this

      this.rows = this.data.filtrados
        .map(map => {
          return _this.toRows(map)
        })
        .sort((a, b) => {
          return !a.inicio.isBefore(b.inicio)
        })
    },
    toRows(mappedTarifas) {
      let row = {}
      row["hab"] = `${this._$formatDMY(mappedTarifas.desde)} - ${this._$formatDMY(mappedTarifas.hasta)}`
      row["observacion"] = mappedTarifas.observacionVigencia
      row["caracteristicas"] = this.toArray(mappedTarifas.caracteristicas.caracteristica)
      row["notas"] = mappedTarifas.notas
      row["aplicaDias"] = mappedTarifas.aplicaDias
      row["inicio"] = moment(mappedTarifas.desde)
      mappedTarifas.tarifas.tarifa.forEach(t => {
        let monto = t.venta

        if (t.moneda === "ARS") {
          monto = parseFloat(monto) + parseFloat(t.iva)
          monto = monto.toFixed(2)
        }
        console.log("monto " + monto)
        row[t.ocupacion] = monto
      })
      row["unique"] = `${row.inicio}-${row.DBL}`
      return row
    }
  },
  data() {
    return {
      expand: false,
      rows: [],
      header: [
        {
          text: "Vigencia",
          sortable: true,
          align: "center",
          value: "vigencia"
        },
        {
          align: "center",
          text: "SGL",
          sortable: false,
          value: "SGL"
        },
        {
          align: "center",
          text: "DBL",
          sortable: false,
          value: "DBL"
        },
        {
          align: "center",
          text: "TPL",
          sortable: false,
          value: "TPL"
        },
        {
          align: "center",
          text: "CPL",
          sortable: false,
          value: "CPL"
        },
        {
          align: "center",
          text: "CHD",
          sortable: false,
          value: "CHD"
        },
        {
          align: "center",
          text: "JR",
          sortable: false,
          value: "JR"
        },
        {
          align: "center",
          text: "Observación",
          sortable: false,
          value: "observacion"
        },
        {
          align: "center",
          text: "Ver detalle",
          sortable: false,
          value: "accion"
        }
      ]
    }
  }
}
</script>
